import { getTemplateNavHeaderPrimaryStyles } from './NavHeaderPrimary.styles'

const t = document.createElement('template')
t.innerHTML = `
<div aria-label="Primary navigation" class="primary-nav">
  <div class="nav-links">
    <slot></slot>
  </div>
</div>
`

class NavHeaderPrimaryLinks extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderPrimaryStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderPrimaryLinks connectedCallback', this)

    const shadow = this.shadowRoot
    if (!shadow) return

    const slot = shadow.querySelector('slot') as HTMLSlotElement | null
    if (!slot) return

    const setDefaultActive = () => {
      const assigned = slot
        .assignedElements({ flatten: true })
        .filter(
          (el) => el.tagName && el.tagName.toLowerCase() === 'ts-navheader-primary-link',
        ) as HTMLElement[]

      if (assigned.length > 0) {
        assigned.forEach((el) => el.classList.remove('tab-active-link'))
        assigned[0].classList.add('tab-active-link')
      }
    }

    requestAnimationFrame(setDefaultActive)

    slot.addEventListener('click', (e: Event) => {
      const path = e.composedPath()

      const clicked = path
        .filter((n): n is HTMLElement => n instanceof HTMLElement)
        .find((n) => n.tagName.toLowerCase() === 'ts-navheader-primary-link')

      if (!clicked) return

      const assigned = slot
        .assignedElements({ flatten: true })
        .filter(
          (el) => el.tagName && el.tagName.toLowerCase() === 'ts-navheader-primary-link',
        ) as HTMLElement[]

      assigned.forEach((el) => el.classList.remove('tab-active-link'))
      clicked.classList.add('tab-active-link')
    })
  }
}

if (!customElements.get('ts-navheader-primary-links')) {
  customElements.define('ts-navheader-primary-links', NavHeaderPrimaryLinks)
}

export { NavHeaderPrimaryLinks }
